import React, { useState, useCallback } from 'react';
import { UsersTable } from '../components/users/UsersTable';
import { CreateUserModal } from '../components/users/CreateUserModal';
import { User } from '../types/user';
import { useI18n } from '../contexts/I18nContext';
import '../styles/users.css';

export const UsersPage: React.FC = () => {
  const { formatTime, t } = useI18n();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshUsers, setRefreshUsers] = useState(0);
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date());

  const handleUserCreated = (_user: User) => {
    setRefreshUsers(prev => prev + 1);
    setLastUpdated(new Date());
  };

  const handleRefresh = useCallback(() => {
    setRefreshUsers(prev => prev + 1);
    setLastUpdated(new Date());
  }, []);

  return (
    <div className="page users-page">
      <div className="page-header">
        <div className="page-title">
          <h1>{t('users.title')}</h1>
          <p>{t('users.subtitle')}</p>
        </div>
        <div className="page-actions">
          <div className="last-updated">
            Last updated: {formatTime(lastUpdated)}
          </div>
          <button className="refresh-button" onClick={handleRefresh}>
            Refresh
          </button>
          <button
            className="create-user-btn"
            data-testid="btn-add-user"
            onClick={() => setShowCreateModal(true)}
          >
            <span className="add-type-icon" aria-hidden="true">+</span>
            Add User
          </button>
        </div>
      </div>

      <div className="page-content users-content">
        <UsersTable
          onUserSelect={() => {}}
          refreshTrigger={refreshUsers}
        />
      </div>

      <CreateUserModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onUserCreated={handleUserCreated}
      />
    </div>
  );
};
